import { Col, Row, Form, Input, Button, List, Badge } from "antd";
import { ImWhatsapp } from "react-icons/im";
import { ImageUrl } from "../../../config/helper";
import { Container } from "postcss";
import { FaArrowRightLong } from "react-icons/fa6";

import { FaCheckCircle } from "react-icons/fa";
import { Get } from "../../../config/api/get";
import { PLAN } from "../../../config/constants/api";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const onFinish = (values) => {
  console.log("Success:", values);
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

const HomeComponent10 = () => {
  const token = useSelector((state) => state.user.userToken);
  const data1 = [
    {
      title: "Monthly",
      savePercent: 15,
      time: "123",
      hours: 30,
      eachBookinghours: 6,
      shadul: "Schedule Your Way",
      monthly: "Monthly Automated Payment",
    },
    {
      title: "Weekly",
      savePercent: 25,
      time: "123",
      hours: 30,
      shadul: "Weekly 4 To 5 Times Service",
      monthly: "Monthly Automated Payment",
    },
    {
      title: "Yearly",
      savePercent: 35,
      time: "123",
      hours: 40,
      eachBookinghours: 8,
      shadul: "Weekly 4 To 5 Times Service",
      monthly: "Monthly Automated Payment",
    },
  ];
  const navigate = useNavigate();
  const [plans, setPlans] = useState(null);
  const getPlans = async () => {
    Get(PLAN.getPlans)
      .then((response) => {
        if (response?.status) {
          setPlans(response?.data);
        }
      })
      .catch((err) => {
        console.log(err, "Error fetching Plans");
      });
  };
  const userData = useSelector((state) => state.user.userData);

  useEffect(() => {
    getPlans();
  }, []);

  return (
    <>
      <section className=" py-16" id="members-section">
        <Row justify={"center"}>
          <Col lg={20}>
            <Row justify="center" className="items-center">
              <Col xxl={24} md={24} sm={24} xs={24}>
                <h3 className="font-goldman text-white xldesktop:text-[65px] laptop:text-[46px] mobile:text-[32px] leading-[75px] text-center">
                  Our memberships
                </h3>
                <p className="text-[#666666] text-[15px] antialiased text-center">
                  We make sure that your every trip is comfortable
                </p>
              </Col>
            </Row>

            <Row justify="center" className="items-center">
              <Col xxl={24} md={24} sm={24} xs={24}>
                {Array.isArray(plans) && (
                  <div className="flex gap-5 justify-center flex-wrap membership-box">
                    {/* <span>
                    <div className="member-cards">
                      <h5 className="font-goldman text-white xldesktop:text-[22px] laptop:text-[16px] leading-8 font-semibold">
                        Monthly
                      </h5>
                      <h4 className="font-goldman text-white xldesktop:text-[30px] laptop:text-[24px] leading-10 font-semibold">
                        15% Discount
                      </h4>
                      <List
                        itemLayout="horizontal"
                        dataSource={data1}
                        renderItem={(item, index) => (
                          <List.Item>
                            <List.Item.Meta
                              avatar={<FaCheckCircle />}
                              title={<p>{item.title}</p>}
                            />
                          </List.Item>
                        )}
                      />
                      <button
                        className="web-btn2 py-3 xl:px-12 px-3  max-xl:text-xs mt-2 block w-full"
                        // onClick={() => navigate("/signIn")}
                      >
                        Subscribe Now
                      </button>
                    </div>
                  </span> */}

                    {data1.map((plan, index) => {
                      return (
                        <span key={index} className="center-span">
                          <Badge.Ribbon text="Paid Monthly">
                            <div className="member-cards member-card-center">
                              <div className="text-center my-4">
                                <h5 className="font-goldman text-white xldesktop:text-[22px] laptop:text-[16px] leading-8 font-semibold">
                                  {plan?.title}
                                </h5>
                                <h4 className="font-goldman text-white xldesktop:text-[30px] laptop:text-[24px] leading-10 font-semibold">
                                  {plan?.savePercent}% Discount
                                </h4>
                              </div>

                              <div>
                                <List.Item>
                                  <List.Item.Meta
                                    className="flex gap-4"
                                    avatar={<FaCheckCircle className=" " />}
                                    title={
                                      <h2 className="leading-normal font-bold">
                                        {plan?.hoursType} Minimum Of{" "}
                                        {plan?.hours} Hours
                                      </h2>
                                    }
                                  />
                                </List.Item>
                                <List.Item>
                                  <List.Item.Meta
                                    className="flex gap-4"
                                    avatar={<FaCheckCircle className="" />}
                                    title={
                                      <h2 className="leading-normal font-bold">
                                        {plan?.hoursType} Each Booking Is{" "}
                                        {plan?.eachBookinghours} Hours
                                      </h2>
                                    }
                                  />
                                </List.Item>
                                <List.Item>
                                  <List.Item.Meta
                                    className="flex gap-4"
                                    avatar={<FaCheckCircle className="" />}
                                    title={
                                      <h2 className="leading-normal font-bold">
                                        {plan?.hoursType}
                                        {plan?.shadul}
                                      </h2>
                                    }
                                  />
                                </List.Item>
                                <List.Item>
                                  <List.Item.Meta
                                    className="flex gap-4"
                                    avatar={<FaCheckCircle className="" />}
                                    title={
                                      <h2 className="leading-normal font-bold">
                                        {plan?.hoursType}
                                        {plan?.monthly}
                                      </h2>
                                    }
                                  />
                                </List.Item>
                              </div>
                              <button
                                className={`web-btn2 py-3 xl:px-12 px-3 max-xl:text-xs mt-2 block w-full ${
                                  userData?.isGuest || !token
                                    ? "opacity-50 cursor-not-allowed"
                                    : ""
                                }`}
                                onClick={() => {
                                  userData?.isGuest || !token
                                    ? navigate("/register")
                                    : navigate("/buySubscription", {
                                        state: {
                                          type: "Subscription",
                                          planId: plans[index]?._id,
                                          plan: plans[index],
                                        },
                                      });
                                }}
                              >
                                Subscribe Now
                              </button>
                            </div>
                          </Badge.Ribbon>
                          {index === 1 && (
                            <div className="most-populr font-goldman">
                              <h5>Most popular</h5>
                            </div>
                          )}
                        </span>
                      );
                    })}

                    {/* {plans.map((plan, index) => {
                      return (
                        <span key={index} className="center-span">
                          <Badge.Ribbon text="Paid Monthly">
                            <div className="member-cards member-card-center">
                              <div className="text-center my-4">
                                <h5 className="font-goldman text-white xldesktop:text-[22px] laptop:text-[16px] leading-8 font-semibold">
                                  {plan?.title}
                                </h5>
                                <h4 className="font-goldman text-white xldesktop:text-[30px] laptop:text-[24px] leading-10 font-semibold">
                                  Save {plan?.savePercent}%
                                </h4>
                              </div>

                              <div>
                                <List.Item>
                                  <List.Item.Meta
                                    className="flex gap-4"
                                    avatar={<FaCheckCircle className="mb-5" />}
                                    title={
                                      <h2 className="leading-normal font-bold">
                                        {plan?.hoursType} Hours Included:
                                      </h2>
                                    }
                                    description={<p>{plan?.hours} hours</p>}
                                  />
                                </List.Item>

                                <List.Item>
                                  <List.Item.Meta
                                    className="flex gap-4"
                                    avatar={<FaCheckCircle className="mb-5" />}
                                    title={
                                      <h2 className="leading-normal font-bold">
                                        Each Booking Duration:
                                      </h2>
                                    }
                                    description={
                                      <p>
                                        {plan?.bookingDuration} hours (one
                                        booking)
                                      </p>
                                    }
                                  />
                                </List.Item>
                              </div>
                              <button
                                className="web-btn2 py-3 xl:px-12 px-3  max-xl:text-xs mt-2 block w-full"
                                onClick={() => {
                                  navigate("/payment", {
                                    state: {
                                      type: "Subscription",
                                      planId: plan?._id,
                                      total: plan?.dicountedAmount,
                                      plan: plan,
                                    },
                                  });
                                }}
                              >
                                Subscribe Now
                              </button>
                            </div>
                          </Badge.Ribbon>
                          {index === 1 && (
                            <div className="most-populr font-goldman">
                              <h5>Most popular</h5>
                            </div>
                          )}
                        </span>
                      );
                    })} */}
                  </div>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default HomeComponent10;
